import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const getItems = (root) => gsap.utils.toArray(root.querySelectorAll('[data-website-evolution-item]'));

const refreshAfterImagesLoad = (root) => {
    root.querySelectorAll('img').forEach((image) => {
        if (!image.complete) {
            image.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
        }
    });
};

Alpine.data('websiteEvolution', () => ({
    media: null,

    init() {
        const root = this.$root;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            root.classList.add('website-evolution--reduced-motion');
            return;
        }

        const pin = root.querySelector('.website-evolution__pin');
        const track = root.querySelector('.website-evolution__track');

        if (!pin || !track) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);
        refreshAfterImagesLoad(root);

        this.media = gsap.matchMedia();
        this.media.add('(min-width: 768px)', () => {
            const getDistance = () => Math.max(track.scrollWidth - pin.getBoundingClientRect().width, 0);

            if (!getDistance()) {
                return null;
            }

            const tween = gsap.fromTo(
                track,
                { x: 0 },
                {
                    x: () => getDistance() * -1,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: root,
                        start: 'top top',
                        end: () => `+=${getDistance()}`,
                        pin,
                        invalidateOnRefresh: true,
                        anticipatePin: 1,
                        scrub: true,
                        snap: false,
                    },
                }
            );

            getItems(root).forEach((item, index) => {
                const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
                const isShortViewport = viewportHeight <= 1100;
                const isVeryShortViewport = viewportHeight <= 820;
                const lowOffset = isVeryShortViewport ? 2 : isShortViewport ? 4 : 24;
                const highOffset = isVeryShortViewport ? 3 : isShortViewport ? 6 : 32;

                gsap.fromTo(
                    item,
                    {
                        y: index % 2 ? highOffset : lowOffset * -1,
                        rotate: index % 2 ? -2 : 2,
                    },
                    {
                        y: index % 2 ? highOffset * -1 : lowOffset,
                        rotate: index % 2 ? 2 : -2,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: root,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                            invalidateOnRefresh: true,
                        },
                    }
                );
            });

            return () => {
                tween.kill();
            };
        });

        requestAnimationFrame(() => ScrollTrigger.refresh());
    },

    destroy() {
        this.media?.revert();
    },
}));
